import { List, Map } from 'immutable';
import createSelector from '../../utils/reselect';

export const getViolationDetailById = (state: any) => {
    const { violation } = state;
    return violation || Map();
};

export const getViolationDetailLoading = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['violationDetail', 'loading']);
});

export const getViolationDetail = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['violationDetail', 'data']) || Map();
});

export const getViolationEditForm = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['violationEditForm', 'data']) || Map();
});

export const getUpdateViolationLoader = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['violationData', 'loading']);
});

export const getAddViolationCommentLoader = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['violationComments', 'loading']);
});

export const getViolationCommentList = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['violationComments', 'data']) || List();
});

export const getViolationCommentListLoadingStatus = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['violationComments', 'loading']);
});

export const getLoadMoreViolationCommentList = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['violationComments', 'loadMore']);
});

export const getOpenedViolations = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['openedViolations', 'data']);
});

export const getOpenedViolationsLoading = createSelector(getViolationDetailById, (state) => {
    return state.getIn(['openedViolations', 'loading']);
});
